<template>
  <div class="wrapper wrapper-full-page">
    <div class="full-page" data-color="black">
      <div class="content">
        <div class="container">
          <div class="col-lg-5 col-md-6 col-sm-8 col-xs-12 card mb-n4 mx-auto">
            <h4 class="w-100 text-center mb-3">Фойдаланувчи паролини ўзгартиринг!</h4>
            <div>

              <b-alert show variant="warning" style="border-radius: 6px;">
                <div class="text-white font-weight-bold">
                  <div class="ml-n1" style="font-size: 1rem;">💡Парол қўйиш қоидалари:</div>
                  <ul class="ml-2">
                    <li>Лотин алифбосидан иборат бўлсин</li>
                    <li>8–16 та белги бўлсин</li>
                    <li>Камида 1 та катта ҳарф (A-Z)</li>
                    <li>Камида 1 та кичик ҳарф (a-z)</li>
                    <li>Камида 1 та рақам (0–9)</li>
                    <li>Камида 1 та белги (!@#$% ва ҳ.к.)</li>
                  </ul>
                </div>
              </b-alert>

              <div class="form-group">
                <label> {{ $t('user.field.password') }} <span class="red">*</span></label>
                <div class="input-group">
                  <input
                      :type="showPassword ? 'text' : 'password'"
                      placeholder="Хозирги парол"
                      class="form-control"
                      :class="{invalid: $v.userPassword.password.$error}"
                      v-model="userPassword.password"
                  >
                  <div class="input-group-append">
                    <button class="btn btn-primary mb-0" type="button" @click="handleTogglePassword('showPassword')">
                      <i class="fa fa-eye-slash" v-if="showPassword"/>
                      <i class="fa fa-eye" v-else/>
                    </button>
                  </div>
                </div>
                <div class="helper-error-text" v-if="$v.userPassword.password.$error">
                  {{ $t("user.validation.password") }}
                </div>
              </div>

              <div class="form-group">
                <label> {{ $t('user.field.newPassword') }} <span class="red">*</span></label>
                <div class="input-group">
                  <input
                      :type="showNewPassword ? 'text' : 'password'"
                      placeholder="Янги парол"
                      class="form-control"
                      :class="{invalid: $v.userPassword.newPassword.$error}"
                      v-model="userPassword.newPassword"
                      :disabled="processing"
                      @input="handleInputPassword($event, 'newPassword')"
                  >
                  <div class="input-group-append">
                    <button class="btn btn-primary mb-0" type="button" @click="handleTogglePassword('showNewPassword')">
                      <i class="fa fa-eye-slash" v-if="showNewPassword"/>
                      <i class="fa fa-eye" v-else/>
                    </button>
                  </div>
                </div>
                <div class="helper-error-text" v-if="$v.userPassword.newPassword.$error">
                  {{ $t("user.validation.newPassword") }}
                </div>
                <div class="helper-error-text" v-if="!$v.userPassword.newPassword.minLength">
                  Узунлиги 8 тадан кам бўлмаслиги керак
                </div>
                <div class="helper-error-text" v-if="!$v.userPassword.newPassword.maxLength">
                  Узунлиги 16 тадан кўп бўлмаслиги керак
                </div>
              </div>

              <div class="form-group">
                <label>{{ $t('user.field.passwordConfirm') }} <span class="red">*</span></label>
                <div class="input-group">
                  <input
                      :type="showConfirmPassword ? 'text' : 'password'"
                      placeholder="Паролни тасдиқланг"
                      class="form-control"
                      :class="{invalid: $v.userPassword.newPassword.$error}"
                      v-model="userPassword.passwordConfirm"
                      :disabled="processing"
                      @input="handleInputPassword($event, 'passwordConfirm')"
                  >
                  <div class="input-group-append">
                    <button class="btn btn-primary mb-0" type="button"
                            @click="handleTogglePassword('showConfirmPassword')">
                      <i class="fa fa-eye-slash" v-if="showConfirmPassword"/>
                      <i class="fa fa-eye" v-else/>
                    </button>
                  </div>
                </div>
                <div class="helper-error-text" v-if="$v.userPassword.passwordConfirm.$error">
                  {{ $t("user.validation.passwordConfirm") }}
                </div>
                <div class="helper-error-text" v-if="!$v.userPassword.passwordConfirm.minLength">
                  Узунлиги 8 тадан кам бўлмаслиги керак
                </div>
                <div class="helper-error-text" v-if="!$v.userPassword.passwordConfirm.maxLength">
                  Узунлиги 16 тадан кўп бўлмаслиги керак
                </div>
                <div class="helper-error-text" v-if="userPassword.passwordConfirm && !$v.userPassword.passwordConfirm.sameAsPassword">Пароллар ўзаро мос бўлиши керак!</div>
              </div>
            </div>

            <div class="w-100 pb-2 d-flex align-items-center justify-content-center">
              <button class="all-btn add-btn mr-2" @click="updatePassword" :disabled="processing">
                <i v-if="processing" class="fa fa-spinner fa-spin"></i>
                {{ $t("action.save") }}
              </button>
              <button class="all-btn delete-btn ml-2" @click="logOut" :disabled="processing">
                {{$t("main.logOut")}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bAlert from 'bootstrap-vue/es/components/alert/alert'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
import {mapState} from "vuex";
import {maxLength, minLength, required, sameAs} from "vuelidate/lib/validators";
import {customPassword} from "@/shared/validator-helpers";

export default {
  name: "ForceUpdatePassword",
  components: {
    'b-modal': bModal,
    'b-alert': bAlert
  },
  directives: {
    'b-modal': bModalDirective
  },
  data() {
    return {
      processing: false,
      userPassword: {
        password: '',
        newPassword: '',
        passwordConfirm: ''
      },
      showPassword: false,
      showNewPassword: false,
      showConfirmPassword: false
    }
  },
  validations() {
    return {
      userPassword: {
        password: {
          required: required,
        },
        newPassword: {
          required: required,
          minLength: minLength(8),
          maxLength: maxLength(16),
          customPassword: customPassword
        },
        passwordConfirm: {
          required,
          minLength: minLength(8),
          maxLength: maxLength(16),
          customPassword: customPassword,
          sameAsPassword: sameAs('newPassword')
        }
      }
    }
  },
  computed: {
    ...mapState(['profile'])
  },
  methods: {
    updatePassword() {
      this.$v.userPassword.$touch();
      if (this.$v.userPassword.$invalid) {
        return;
      }

      this.processing = true;
      this.user.changePassword = true;
      this.user.password = this.userPassword.password;
      this.user.newPassword = this.userPassword.newPassword;
      this.user.passwordConfirm = this.userPassword.passwordConfirm;

      let vm = this;

      this.$http.post('/user/profile/save', this.user)
          .then(res => {
            console.log(res.data);
            this.processing = false;
            if (res.data.status === 'SUCCESS') {
              vm.$swal({
                title: vm.$t('messages.common.success'),
                text: vm.$t('messages.common.saved'),
                type: 'success',
                html: res.data.message
              });

              vm.$store.dispatch('logOut');

            } else if (res.data.status === 'FAIL') {
              vm.$swal({
                title: vm.$t('messages.common.warning'),
                text: vm.$t('messages.common.errorOccurred'),
                type: 'warning',
                html: res.data.message
              });
            } else {
              vm.$swal({
                title: vm.$t('messages.common.warning'),
                text: vm.$t('messages.common.errorOccurred'),
                type: 'warning',
                html: res.data.message
              });
            }
          }, (res) => {
            this.processing = false;
            vm.$swal({
              title: vm.$t('messages.common.error'),
              text: vm.$t('messages.common.errorOccurred'),
              type: 'error',
              html: res.data.message
            });
          })
    },
    handleInputPassword(event, fieldName) {
      if (this.userPassword.hasOwnProperty(fieldName) && event.target && event.target.value) {
        // eslint-disable-next-line
        this.userPassword[fieldName] = event.target.value.replace(/[^A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/g, '');
      }
    },
    handleTogglePassword(fieldName) {
      if (this.hasOwnProperty(fieldName)) {
        this[fieldName] = !this[fieldName];
      }
    },
    logOut() {
      this.$store.dispatch('logOut');
    }
  },
  created() {
    if (this.profile && this.profile.forceUpdatePassword) {
      this.user = JSON.parse(JSON.stringify(this.profile))
    } else {
      this.$router.push('/real-estate')
    }
  }
}
</script>